jQuery(document).ready(function ($) {
    $('.mMenu').on('click', function () {
        var header = $('#site-header')
        if (header.hasClass('navOpen')) {
            $('#site-header').removeClass('navOpen')
        } else {
            $('#site-header').addClass('navOpen')
        }
    });

    $('.icon-search, .searchWrp, .searchclose').on('click', function () {
        $('html, body').toggleClass('searchOpen');
    });
});